import {
  initialState,
  Actions,
  State,
  GET_ALL_USERS,
  GET_ALL_USERS_SUCCESS,
  GET_ALL_USERS_ERROR,
  RESET_ALL_USERS,
} from '../../types/user/get-all'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_USERS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ALL_USERS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ALL_USERS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_ALL_USERS:
      return initialState
    default:
      return state
  }
}

export default reducers
